<div class="virtual-keyboard-panel" (click)="$event.stopPropagation()">
    <div class="vk-row vk-text-row">
        <input #vkInput
               type="text"
               class="vk-input"
               placeholder="Digite o texto e envie para a sessão"
               autocomplete="off"
               autocapitalize="off"
               spellcheck="false"
               (keydown.enter)="sendText(vkInput, true)">
        <button mat-flat-button color="accent" class="vk-send" [disabled]="!canSend()" (click)="sendText(vkInput)"
                matTooltip="Envia só o texto, sem Enter (a tecla Enter no campo envia o texto + Enter)">
            Enviar
        </button>
        <button mat-icon-button class="vk-close" matTooltip="Fechar teclado virtual" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="vk-row vk-special-row">
        @for (key of specialKeys; track key.label) {
            <button mat-stroked-button class="vk-key" [disabled]="!canSend()" (click)="sendSpecialKey(key)" [matTooltip]="key.label">
                @if (key.icon) {
                    <mat-icon [inline]="true">{{ key.icon }}</mat-icon>
                } @else {
                    {{ key.label }}
                }
            </button>
        }
    </div>
    @if (!canSend()) {
        <div class="vk-hint">Nenhuma sessão ativa — abra um aplicativo para usar o teclado virtual.</div>
    }
</div>
